import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import Dashboard from 'services/Dashboard'
import PieChart from 'components/Charts/PieChart'
import ColumnChart from 'components/Charts/ColumnChart'
import HistoryDialog from 'components/Charts/HistoryDialog'
import Select from 'components/Inputs/Select'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'

import {
  InfoContainer,
  FilterContainer,
  LoadingContainer,
  SubTitle,
  InfoText,
  LinkText
} from '../../styles'

export default function TopServices ({
  data: services,
  month = DateTime.now ().month,
  year = DateTime.now ().year
}) {
  const selectedDate = DateTime.local (year, month).setLocale ('pt-BR')
  const formattedDate = selectedDate.toFormat ('MMM yyyy')
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()
  const periodFilterOptions = Dashboard.PERIOD_FILTERS
  const [loading, setLoading] = useState (true)
  const [isMounted, setMounted] = useState (false)
  const [periodFilter, setPeriodFilter] = useState (null)
  const [showDetails, setShowDetails] = useState (false)
  const [servicesByMonth, setServicesByMonth] = useState ([])

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    if (isMounted) setPeriodFilter (periodFilterOptions[0])
  }, [isMounted])

  useEffect (() => {
    getData ()
  }, [periodFilter])

  const getData = async () => {
    if (showDetails) try {
      setLoading (true)

      const startDate = selectedDate.minus ({ months: periodFilter.value }).startOf ('month').toISODate ()
      const endDate = selectedDate.endOf ('month').toISODate ()
      const filters = `start_date=${startDate}&end_date=${endDate}`

      const { data: topServices } = await cutileiApi.get (
        `/businesses/${businessId}/top_services?${filters}`, requestConfig
      )

      const services = Dashboard.getKeysFromPeriod (topServices)

      setServicesByMonth ([
        ['Serviços', ...services],
        ...Object.values (topServices).map ((month, index) => ([
          Object.keys (topServices)[index],
          ...services.map (name => month[name]?.totalValue || 0)
        ]))
      ])
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const toggleDetails = () => {
    if (!isMounted) setMounted (true)
    setShowDetails (!showDetails)
  }

  if (!services || Object.keys (services).length === 0) {
    return null
  }

  const topServices = [
    ['Serviço', 'Valor (R$)'],
    ...Object.keys (Object.values (services)[0] || {}).map (data => ([
      data,
      services?.[formattedDate]?.[data]?.totalValue || 0
    ]))
  ]

  return (
    <InfoContainer>
      <SubTitle>Top 10 serviços mais vendidos</SubTitle>
      <PieChart data={topServices}/>
      <LinkText onClick={toggleDetails}>
        Ver histórico
      </LinkText>
      <HistoryDialog
        visible={showDetails}
        title='Top 10 serviços mais vendidos'
        onClose={toggleDetails}
      >
        <FilterContainer style={{minWidth: 250}}>
          <Select
            name='timeFilter'
            placeholder='Período...'
            value={periodFilter}
            options={periodFilterOptions}
            onChange={(_, option) => setPeriodFilter (option)}
          />
        </FilterContainer>
        {loading ? (
          <LoadingContainer>
            <Loading/>
            <InfoText>Gerando gráfico...</InfoText>
          </LoadingContainer>
        ) : (
          <ColumnChart
            data={servicesByMonth}
            options={{
              height: 450,
              chartArea: {
                top: 30, left: 110, width: '100%', height: '75%'
              }
            }}
          />
        )}
      </HistoryDialog>
    </InfoContainer>
  )
}
